module.exports = __webpack_public_path__ + "img/plus.7e457c08.png";